export default __webpack_public_path__ + "static/media/new-pitch.79f36bd9.png";